import React from 'react';

// material-ui
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import { Box, Button, Chip, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';

// project imports
import AnimateButton from 'ui-component/extended/AnimateButton';
import constants from '../../../../constants';
import { useLanguage } from '../../../../context/LanguageContext';

// ===========================|| PROFILE MENU - UPGRADE PLAN CARD ||=========================== //

const UpgradePlanCard = () => {
  const theme = useTheme();
  const matchDownSm = useMediaQuery(theme.breakpoints.down('sm'));
  const { t } = useLanguage();
  const labelJoin = t('labelJoin', 'Upgrade Now');
  const labelJoinPremium = t('labelJoinPremium', 'Upgrade Now');
  const upCTAlabel = t('upCTAlabel', 'Upgrade for Ad-free and More');
  const upCTAPrice = t('upCTAPrice', 'Just ₹1050 ~ $13.');
  const labelDiscount = t('lDiscount', '90% Off');

  const handleUpgrade = () => {
    window.location.href = constants.premium.endpoint;
  };

  return (
    <Box
      sx={{
        position: 'relative',
        overflow: 'hidden',
        mt: 2,
        mb: 1,
        p: matchDownSm ? 2 : 2.5,
        borderRadius: 4,
        color: '#fff',
        background: 'linear-gradient(145deg, #071a3d 0%, #0f5fc8 48%, #6d5dfc 100%)',
        border: '1px solid rgba(255,255,255,0.26)',
        boxShadow: '0 22px 54px rgba(15,73,132,0.26)'
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          width: 136,
          height: 136,
          right: -44,
          top: -50,
          borderRadius: '50%',
          background: 'rgba(255,255,255,0.16)'
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          width: 92,
          height: 92,
          left: -36,
          bottom: -42,
          borderRadius: '50%',
          background: 'rgba(24,201,139,0.22)'
        }}
      />

      <Stack spacing={1.7} sx={{ position: 'relative', zIndex: 1 }}>
        <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between">
          <Box
            sx={{
              width: 42,
              height: 42,
              display: 'grid',
              placeItems: 'center',
              borderRadius: 3,
              background: 'rgba(255,255,255,0.15)',
              border: '1px solid rgba(255,255,255,0.24)'
            }}
          >
            <WorkspacePremiumIcon sx={{ fontSize: 22, color: '#fff' }} />
          </Box>
          <Chip
            label={labelDiscount}
            size="small"
            sx={{
              borderRadius: 999,
              color: '#dff7ff',
              background: 'rgba(255,255,255,0.14)',
              border: '1px solid rgba(255,255,255,0.18)',
              fontWeight: 900
            }}
          />
        </Stack>

        <Box>
          <Typography variant={matchDownSm ? 'h4' : 'h3'} sx={{ color: '#fff', fontWeight: 900, letterSpacing: 0, lineHeight: 1.12 }}>
            {labelJoinPremium}
          </Typography>
          <Typography sx={{ mt: 1, color: 'rgba(255,255,255,0.78)', fontWeight: 600, lineHeight: 1.5 }}>
            {upCTAlabel}. {upCTAPrice}
          </Typography>
        </Box>

        <AnimateButton>
          <Button
            fullWidth
            onClick={handleUpgrade}
            sx={{
              minHeight: 44,
              borderRadius: 3,
              color: '#0b234d',
              background: '#ffffff !important',
              backgroundColor: '#ffffff !important',
              border: '1px solid #ffffff',
              boxShadow: '0 14px 28px rgba(4,16,35,0.24)',
              fontWeight: 900,
              textTransform: 'none',
              '&:hover': {
                background: '#ffffff !important',
                backgroundColor: '#ffffff !important',
                boxShadow: '0 18px 34px rgba(4,16,35,0.3)'
              },
              '&:active': {
                background: '#ffffff !important',
                backgroundColor: '#ffffff !important'
              }
            }}
          >
            {labelJoin}
          </Button>
        </AnimateButton>
      </Stack>
    </Box>
  );
};

export default UpgradePlanCard;
